import AutoplayModel from "../../../core/src/model/AutoplayModel";
import PointerEvents from "../../../core/src/const/PointerEvents";
import {
  StartAutoplayCommand,
  StopAutoplayCommand,
} from "../../../core/src/commands/GameCommands";
import BetModel from "../../../core/src/model/BetModel";
import ViewManager from "../../../core/src/utils/ViewManager";
import UIController from "../../../core/src/ui/UIController";
import SoundController from "../../../core/src/utils/SoundController";
import SoundVars from "../../../core/src/const/SoundVars";
import CommandManager from "../../../core/src/commands/CommandManager";
import { Commands } from "../../../core/src/commands/CommandEnum";
import SwitchButton from "../../../core/src/views/components/SwitchButton";
import GameModel from "../../../core/src/model/GameModel";
import { ConfigurationTypes } from '../../../core/src/const/ConfigurationTypes';
import ConfigManager from '../../../core/src/managers/ConfigManager';
import IVendorClientConfigRequestData from '../../../server/requests/contracts/IVendorClientConfigRequestData';

export default function showAutoplayPage() {
  let scene = ViewManager.getLayer("MenusContent").setScene("autoplay");
  let autospins = scene.buttonGroups.get("spinsCount");
  let lossLimit = scene.buttonGroups.get("lossAmount");
  let singleWinLimit = scene.buttonGroups.get("winAmount");
  let clearBtn = scene.buttons.get("clear");
  let playBtn = scene.buttons.get("play");


  // Auto-play - Autoplay is not supported [Lithuania]
  let isFeatureAllowed = !ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.autoplayDisable;

  ////////////////
  // AUTO SPIN COUNT
  ////////////////
  let autospinValues = AutoplayModel.spinPresets;
  if (autospinValues.length == 0) {
    autospinValues = [5, 10, 25, 50, 100];
  }
  autospins.replaceButtonTexts((value, index) =>
    value.replace("{0}", `${autospinValues[autospinValues.length - 1 - index]}`)
  );

  // Loop through the values to select the current one
  autospins.getChildren().forEach((child: SwitchButton) => {
    child.setEnabled(isFeatureAllowed);
    child.switch(
      parseFloat(child.getValue()) == AutoplayModel.getAutoSpinNum()
    );
  });

  ////////////////
  // LOSS LIMIT
  ////////////////
  let lossLimits = AutoplayModel.lossLimits;
  if (lossLimits.length == 0) {
    lossLimits = [2, 5, 10, 20];
  }
  lossLimit.replaceButtonTexts((value, index) => {
    // let bet = BetModel.formatCurrency(BetModel.totalBet);
    return value.replace("{0}", `${lossLimits[lossLimits.length - 1 - index]}x`)
  });
  // Loop through the values to select the current one
  lossLimit.getChildren().forEach((child: SwitchButton) => {
    child.setEnabled(isFeatureAllowed);
    let buttonValue = Number(child.getValue().split("x")[0]) * BetModel.totalBet;
    child.switch(buttonValue == AutoplayModel.getLossLimit());
  });

  ////////////////
  // WIN LIMIT
  ////////////////
  let singleWinLimits = AutoplayModel.singleWinLimits;
  if (singleWinLimits.length == 0) {
    singleWinLimits = [2, 5, 10, 20];
  }
  singleWinLimit.replaceButtonTexts((value, index) => {
    // let bet = BetModel.formatCurrency(BetModel.totalBet);
    return value.replace("{0}", `${singleWinLimits[singleWinLimits.length - 1 - index]}x`)
  });
  // Loop through the values to select the current one
  singleWinLimit.getChildren().forEach((child: SwitchButton) => {
    child.setEnabled(isFeatureAllowed);
    let buttonValue =
      Number(child.getValue().split("x")[0]) * BetModel.totalBet;
    child.switch(buttonValue == AutoplayModel.getWinLimit());
  });

  let updatePlayButton = () => {
    let enabled =
      isFeatureAllowed &&
      autospins.isSelected() &&
      lossLimit.isSelected() &&
      singleWinLimit.isSelected();
    playBtn.setEnabled(enabled);
  };

  clearBtn.setEnabled(isFeatureAllowed);

  const saveSettings = () => {
    CommandManager.execute(Commands.SAVE_SETTINGS);
  };

  lossLimit.onSelect((value) => {
    SoundController.playSound(SoundVars.BUTTON_CLICK);
    value = Number(value.split("x")[0]) * BetModel.totalBet;
    AutoplayModel.setLossLimit(Number(value));
    updatePlayButton();
    saveSettings();
  });

  singleWinLimit.onSelect((value) => {
    SoundController.playSound(SoundVars.BUTTON_CLICK);
    value = Number(value.split("x")[0]) * BetModel.totalBet;
    AutoplayModel.setWinLimit(Number(value));
    updatePlayButton();
    saveSettings();
  });

  autospins.onSelect((value) => {
    SoundController.playSound(SoundVars.BUTTON_CLICK);
    value = Number(value.split("x")[0]);
    AutoplayModel.setAutoSpin(value);
    updatePlayButton();
    saveSettings();
  });

  clearBtn.on(PointerEvents.DOWN, () => {
    SoundController.playSound(SoundVars.BUTTON_CLICK);
    lossLimit.deselect();
    singleWinLimit.deselect();
    autospins.deselect();
    AutoplayModel.setAutoSpin(0);
    AutoplayModel.setWinLimit(0);
    AutoplayModel.setLossLimit(0);
    // StopAutoplayCommand();
    updatePlayButton();
    saveSettings();
  });

  playBtn.off(PointerEvents.DOWN);
  playBtn.on(PointerEvents.DOWN, () => {
    SoundController.playSound(SoundVars.BUTTON_CLICK);
    StartAutoplayCommand();
    UIController.toggleComponent("settings");
  });

  updatePlayButton();
}
